module.exports = __webpack_public_path__ + "images/fd-xp.jpg";